import Navbar from "../../components/Layout/Navbar";
import Footer from "../../components/Layout/Footer";
import PageMeta from "../../components/pagesHelmet/PageMeta";
import QR_IMG from "./image/u2lr.jpeg";

const BRAND = {
  success: "#3B82F6",
  successDark: "#2563EB",
  successSoft: "rgba(59, 130, 246, 0.08)",
  muted: "#6B7280",
  text: "#1F2937",
};

export default function QrCodesPages() {
  return (
    <>
      <PageMeta
        title="Dynamic QR Codes | U2LR"
        description="Generate branded, trackable QR codes for campaigns, events, and marketing with U2LR."
      />
      <Navbar />

      <div style={{ color: BRAND.text }}>

        {/* ================= HERO ================= */}
        <section
          style={{
            background: `linear-gradient(135deg, #0f172a, ${BRAND.successDark})`,
            color: "#fff",
          }}
        >
          <div className="container py-5">
            <div className="row py-5 align-items-center">
              <div className="col-lg-6">
                <h1 className="display-4 fw-bold mb-4">
                  Turn Offline Traffic Into Measurable Results
                </h1>

                <p
                  className="lead mb-4"
                  style={{ color: "rgba(255,255,255,0.85)" }}
                >
                  Create dynamic, branded QR codes that connect physical
                  experiences to real-time digital insights.
                </p>

                <div className="d-flex gap-3 flex-wrap">
                  <a
                    href="/register"
                    className="btn btn-light btn-lg rounded-pill px-4 fw-semibold"
                    style={{ color: BRAND.successDark }}
                  >
                    Generate QR Code
                  </a>

                  <a
                    href="/pricing"
                    className="btn btn-outline-light btn-lg rounded-pill px-4"
                  >
                    View Pricing
                  </a>
                </div>

                <p
                  className="mt-3 small"
                  style={{ color: "rgba(255,255,255,0.7)" }}
                >
                  Dynamic • Editable • Trackable
                </p>
              </div>

              <div className="col-lg-6 text-center">
                <img
                  src={QR_IMG}
                  alt="U2LR QR Dashboard"
                  className="img-fluid rounded-4 shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* ================= TRUST STRIP ================= */}
        <section className="py-4 bg-light text-center">
          <div className="container">
            <div className="row text-muted small">
              <div className="col-md-4">✔ Editable destinations anytime</div>
              <div className="col-md-4">✔ Real-time scan tracking</div>
              <div className="col-md-4">✔ Works for print & digital campaigns</div>
            </div>
          </div>
        </section>

        {/* ================= FEATURES ================= */}
        <section
          className="py-5"
          style={{ background: BRAND.successSoft }}
        >
          <div className="container py-4">

            <div className="text-center mb-5">
              <h2 className="fw-bold">Powerful QR Code Features</h2>
              <p style={{ color: BRAND.muted }}>
                Built for marketers, events, retail, and fast-moving teams.
              </p>
            </div>

            <div className="row g-4">
              {[
                {
                  title: "Dynamic QR Codes",
                  desc: "Update the destination URL anytime without changing the QR code.",
                },
                {
                  title: "Scan Analytics",
                  desc: "Track scans by device, browser, location, and time.",
                },
                {
                  title: "Custom Branding",
                  desc: "Add logos and brand colors to make your QR codes recognizable.",
                },
                {
                  title: "Campaign Integration",
                  desc: "Connect QR codes directly to campaigns and marketing funnels.",
                },
                {
                  title: "Bulk Generation",
                  desc: "Create multiple QR codes instantly for large-scale promotions.",
                },
                {
                  title: "Secure & Reliable",
                  desc: "Fast redirection and secure infrastructure you can trust.",
                },
              ].map((item, i) => (
                <div key={i} className="col-md-6 col-lg-4">
                  <div className="card h-100 border-0 shadow-sm rounded-4 p-4">
                    <h5 className="fw-bold mb-3">{item.title}</h5>
                    <p className="mb-0" style={{ color: BRAND.muted }}>
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ================= HOW IT WORKS ================= */}
        <section className="py-5">
          <div className="container py-4 text-center">
            <h2 className="fw-bold mb-5">How It Works</h2>

            <div className="row g-4">
              {[
                "Create a short link",
                "Generate your QR code",
                "Print or share it",
                "Track scans in real time",
              ].map((step, i) => (
                <div key={i} className="col-md-3">
                  <div className="p-4">
                    <div
                      className="fw-bold mb-3"
                      style={{
                        fontSize: "2rem",
                        color: BRAND.success,
                      }}
                    >
                      {i + 1}
                    </div>
                    <p className="mb-0">{step}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ================= USE CASE SECTION ================= */}
        <section className="py-5 bg-light text-center">
          <div className="container py-4">
            <h2 className="fw-bold mb-3">
              Perfect for Events, Retail & Marketing
            </h2>
            <p className="mb-4" style={{ color: BRAND.muted }}>
              Drive engagement from flyers, packaging, storefronts,
              business cards, and campaigns — all measurable.
            </p>

            <a
            style={{ background: BRAND.successDark, color: "#fff" }}
              href="/register"
              className="btn btn-lg rounded-pill px-5"
            >
              Start Creating QR Codes
            </a>
          </div>
        </section>

        {/* ================= FINAL CTA ================= */}
        <section
          className="py-5 text-center"
          style={{
            background: BRAND.successDark,
            color: "#fff",
          }}
        >
          <div className="container py-4">
            <h2 className="fw-bold mb-3">
              Make Every Scan Count
            </h2>
            <p className="mb-4" style={{ color: "rgba(255,255,255,0.8)" }}>
              Turn physical engagement into measurable digital performance.
            </p>
            <a
              href="/register"
              className="btn btn-light btn-lg rounded-pill px-5 fw-semibold"
              style={{ color: BRAND.successDark }}
            >
              Get Started Free
            </a>
          </div>
        </section>

      </div>

      <Footer />
    </>
  );
}
